import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.0156 4.76531L6.26561 8.51531C6.23078 8.55018 6.18942 8.57784 6.1439 8.59671C6.09837 8.61558 6.04958 8.62529 6.0003 8.62529C5.95101 8.62529 5.90222 8.61558 5.85669 8.59671C5.81117 8.57784 5.76981 8.55018 5.73498 8.51531L1.98498 4.76531C1.93248 4.71287 1.89672 4.64602 1.88222 4.57324C1.86773 4.50046 1.87515 4.42501 1.90356 4.35645C1.93197 4.28789 1.98008 4.22931 2.0418 4.1881C2.10352 4.1469 2.17608 4.12494 2.2503 4.125H9.7503C9.82451 4.12494 9.89707 4.1469 9.95879 4.1881C10.0205 4.22931 10.0686 4.28789 10.097 4.35645C10.1254 4.42501 10.1329 4.50046 10.1184 4.57324C10.1039 4.64602 10.0681 4.71287 10.0156 4.76531Z",
		fill: "current"
	})
});
export default SvgCaretDown;
